const MAIN_TITLE = '不吐皮儿'

let baseURL = ''
const CONFIG_URL = "https://api.82peel.com/ver/1.txt";

const H5_URL = 'https://h5.82peel.com'

if (process.env.NODE_ENV === 'development') {
  // baseURL = 'http://192.168.1.169:6900' // 石头的base_url
  // baseURL = 'http://192.168.1.45:6900' // 周昊的base_url
  // baseURL = 'http://192.168.1.80:6900' // 鲨鱼的base_url
  baseURL = 'https://api.wine.mall.mayiweb.com'
  // baseURL = 'https://api.82peel.com'
} else if (process.env.NODE_ENV === 'production') {
  /* 第二层if，根据.env文件中的VUE_APP_FLAG判断是生产环境还是测试环境 */
  if (process.env.VUE_APP_FLAG === 'pro') {
    // production 生产环境
    baseURL = 'https://api.82peel.com'
  } else {
    // test 测试环境
    baseURL = 'https://api.wine.mall.mayiweb.com'
  }
}

const PRODUCT_TYPE_MAP = [
  { value: 1, text: '跨境配送' },
  { value: 2, text: '香港自提' },
  { value: 3, text: '境内商品' },
  { value: 4, text: '服务类' }
]

const ARTICLE_TYPE_MAP = [
  { value: 1, text: '淘酒攻略' },
  { value: 2, text: '买酒必入' },
  { value: 3, text: '生活美学' },
  { value: 4, text: '观点八卦' }
]

const AREA_CODE_MAP = [
  {
    text: '中国大陆',
    code: '86'
  },
  {
    text: '香港',
    code: '852'
  }
]

const imageHolder = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'

export {
  baseURL,
  MAIN_TITLE,
  PRODUCT_TYPE_MAP,
  ARTICLE_TYPE_MAP,
  AREA_CODE_MAP,
  CONFIG_URL,
  imageHolder,
  H5_URL
}
